export default {
  BUTTON: {
    APPLY: "Aplicar",
    NONE: "Ninguna",
    SAVE_CHANGES: "Guardar Cambios",
    PROCEED: "Continuar",
    DISMISS: "Descartar",
    CONNECT: "Conectar",
    CONNECT_WALLET: "Conectar cartera",
    DISCONNECT: "Desconectar",
    LOGOUT: "Cerrar sesión",
    CLOSE: "Cerrar",
    SETTINGS: "Ajustes",
    LAUNCH_APP: "Iniciar App",
    CONNECT_TO_PROCEED: "Conectar cartera",
    VIEW_DETAILS: "Ver detalles",
    REFRESH: "Refrescar",
    START_REGISTRATION: "Iniciar registro",
    CANCEL: "Cancelar",
    PRESS_ENTER: "Presione Entrar",
    LEARN_MORE: "Más información",
    CLOSE_WINDOW: "Cerrar ventana",
    SHOW_AVAILABLE_ONLY: "Mostrar sólo disponible",
    SHOW_AVAILABLE: "Mostrar sólo disponible",
    PROCEED_SEARCH: "Proceder búsqueda",
    DOWNLOAD: "Descargar",
    SHOW_ALL: "Mostrar todo",
    DESELECT_ALL: "Deseleccionar todo",
    SHOW_SELCTED: "Mostrar seleccionados",
    LINK: "Enlace",
    CUSTOM_LINK: "Enlace personalizado",
    SET_QR_LINK_ALL: "Establecer todos los enlaces QR",
    SET_QR_LINK: "Establecer todos los enlaces QR",
    DISABLE_ALL: "Desactivar todo",
    DISABLE_QR_CODE: "Desactivar código QR",
    ENABLE_QR_CODE: "Habilitar código QR",
    SET_QR_COLOR: "Establecer color QR",
    SET_COLOR: "Definir color",
    SET_ALL_COLORS: "Establecer todos los colores",
    SET_PRICE: "Fijar Precio",
    SET_PRICE_ALL: "Fijar precio todo",
    RESET: 'Reset',
    CHECK_PROFILE: "Comprobar perfil",
    GO_TO_DASHBOARD: "Ir al Tablero",
    GO_TO_HOME: "Ir a Inicio",
    VIEW_PROFILE: "Ver perfil",
    CHECK_DOMAINS: "Comprobar dominios",
    TRANSACTION_DETAILS: "Detalles de la transacción",
    BUY_NOW: "Comprar ahora",
    CLEAR_HISTORY: "Borrar el Historial",
    DEFAULT: "Predeterminado",
    CUSTOM: "Personal",
    FRACTIONALISE: "Fraccionalizar",
    MORE_INFO: "Más información",
    LESS_INFO: "Menos Info",
    APPROVE: "Aprobar",
    NEXT: "Próximo",
    PENDING: "Pendiente",
    REMOVE: "Eliminar",
    REMOVE_ALL_ITEMS: "Eliminar todos los artículos",
    ADD_ALL_TO_CART: "Añadir Todo al Carrito",
    BOOKMARK_ALL: "Marcar todas las pestañas",
    DOWNLOAD_LIST: "Lista de descargas",
    SHARE_LIST: "Compartir lista",
    MORE: "Más",
    CHANGE: "Cambiar",
    TRY_AGAIN: "Inténtalo de nuevo"
  },
  HEADER: {
    ABOUT: "Acerca de",
    FAQ: 'FAQs',
    BACK_TO_HOME: "Volver a Inicio",
    HOME: "Casa",
    CATEGORIES: "Categorías",
    HELP_SUPPORT: "Ayuda y soporte",
    HELP: "Ayuda",
    CANCEL_REGISTRATION: "Cancelar Registro",
    PROFILE: "Perfil",
    SETTINGS: "Ajustes",
    DOCS: "Documentos",
    DOCUMENTATIONS: "Documentaciones",
    CART: "Carrito",
    BOOKMARKS: "Marcadores",
    PAYMENTS_HISTORY: "Historial de pago",
    LIGHT_MODE: "Modo Claro",
    CUSTOM_RPC: "RPC Personalizado",
    SETUP_REQUIRED: "Se requiere configuración",
    MANAGE_DOMAINS: "Administrar dominios",
    APPROVE: "Aprobar",
    FEATURE_DISABLED: "Función deshabilitada",
    ERROR: 'Error'
  },
  IPFS: {
    INITIALISING: "Iniciando p2p",
    FINDING_PEERS: "Encontrando pares",
    FAILED: "Fallo",
    READY: "Listo",
    PUBLISHING: "Publicación"
  },
  EVENTS: {
    TRANSFER: "Transferir",
    REGISTRATION: "Registro",
    RENEWAL: "Renovación",
    SALE: "Venta",
    MINT: "Moneda",
    BURN: "Quemar"
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE: "La red no es compatible. Por favor, cambie su red.",
    IPNS_PUBLISHING_COMPLETED: "¡Publicación completada!",
    PENDING_TRANSACTION_CERATED: "Se ha creado una nueva transacción. Por favor, comprueba tu cartera."
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: "1 semana",
    ONE_MONTH: "1 mes",
    THREE_MONTHS: "3 meses",
    SIX_MONTHS: "6 meses",
    ONE_YEAR: "1 año",
    TWO_YEARS: "2 años",
    THREE_YEARS: "3 años",
    FOUR_YEARS: "4 años",
    FIVE_YEARS: "5 años"
  },
  LABELS: {
    DOWNLOAD_DATA: "Descargar Datos",
    SORT_BY_EXPIRATIONS: "Ordenar por vencimientos",
    SORT_BY_LATEST_REGISTRATIONS: "Ordenar por últimos registros",
    SORT_BY_LONGEST_DURATION: "Ordenar por duración más larga",
    PREMIUM: "Prima",
    ANALYTICS: "Análisis",
    AN_ERROR_HAS_OCCURED: "Se ha producido un error al procesar su solicitud.",
    STOREFRONT_READY_TO_DEPLOY: "El frente de su tienda está listo para ser desplegado. Su tienda se ubicará en:",
    ACCESS_STOREFRONT: "Ahora puede acceder a su tienda en:",
    BUY_ON: "Comprar en",
    MY_PROFILE: "Mi perfil",
    CREATE_STOREFRONT: "Crear escaparate",
    SETUP_PRIMARY_DOMAIN: "Configurar Dominio Principal",
    CHOOSE_A_PRIMARY_DOMAIN: "Elija un dominio principal y enláguelo a su perfil. Este dominio elegido será su enlace de perfil.",
    CREATE_YOUR_STOREFRONT: "Cree su frente de tienda usando su nombre .eth con Predomain Stores. Aprenda más sobre su frente de tienda en:",
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE: "Este dominio está disponible en los siguientes mercados",
    PURCHASE_DOMAINS: "Dominios de compra",
    OWNED_BY: "Propiedad de",
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: "Gestionar artículos destacados",
    VISIT_STOREFRONT: "Visitar tienda",
    OPTIONS: "Opciones",
    FEATURED_ITEMS: "Artículos destacados",
    SORT_BY_CATEGORY: "Ordenar por categoría",
    SELECT_DOMAIN: "Seleccionar dominio",
    SELECT_DOMAINS: "Seleccionar Dominios",
    RENEW_DOMAINS: "Renovar dominios",
    TRANSFER_DOMAINS: "Transferir Dominios",
    BUYER: "Comprador",
    PRICE: "Precio",
    SALE: "Venta",
    ACTIVITY: "Actividad",
    TOP_CATEGORIES: "Categorías principales",
    TOTAL_ASSETS: "Total de activos",
    MONTHLY_SALES: "Ventas mensuales",
    DAILY_VOLUME: "Volumen gas diario",
    MONTHLY_VOLUME: "Volumen gas mensual",
    DAILY_SALES: "Ventas diarias",
    TOP_SALE: "Mejores ventas",
    TOP_SALES: "Mejores ventas",
    TOP_BUYER: "Comprador Top",
    RECENT_SALES: "Ventas recientes",
    SALES_ACTIVITY: "Actividad de ventas",
    ENTER_NAMES_TO_SEARCH: "Introducir nombres para buscar",
    NOT_AVAILABLE: "No Disponible",
    VOLUME: "Volumen",
    FLOOR: "Piso",
    FILTER: "Filtro",
    RENEWAL_DURATION: "Duración de la renovación",
    TRANSACTION: "Transacción",
    USER_PROFILE: "Perfil de usuario",
    FEATURE_DISABLED: "Esta opción está actualmente deshabilitada",
    COMPLETE: "Completada",
    ESTIMATED_COST: "Costo Estimado",
    ADDRESS: "Dirección",
    TRANSFER: "Transferir",
    PLEASE_WAIT: "Por favor espera",
    SELECT_A_DOMAIN: "Seleccione un dominio",
    RENEW: "Renovar",
    MANAGE_DOMAINS: "Administrar dominios",
    SEARCH_FOR: "Buscar por",
    MANAGE: "Gestionar",
    COLLECT: "Coleccionar",
    LANDING_TEXT: "Fuente abierta, descentralizada, Web3 dominios de búsqueda, registro y mercado.",
    PROFILE: "Perfil",
    GO_TO_PROFILE: "Ir al perfil",
    SEARCH: "Buscar",
    CONTAIN_ALPHABET: "Contiene el alfabeto",
    CONTAIN_NUMBERS: "Contiene números",
    CONTAIN_EMOJI: "Contiene Emoji",
    MIN_LENGTH: "Longitud Mínima",
    MAX_LENGTH: "Longitud Máxima",
    CONTAINING_KEYWORDS: "Conteniendo palabras clave",
    FILTERS: "Filtros",
    DOMAINS: "Dominios",
    DOMAIN: "Dominio",
    DOMAIN_HISTORY: "Historial de dominios",
    EXPIRATION_DATE: "Fecha de caducidad",
    REGISTRATION_DATE: "Fecha de registro",
    CREATION_DATE: "Fecha de creación",
    DETAILS: "Detalles",
    YOUR_DOMAINS: "Tus dominios",
    PROCESSING: "Procesando",
    LAYOUT: "Diseño",
    ENTER_SUFFIX: "Introducir sufijo",
    ENTER_PREFIX: "Introduzca prefijo",
    CLICK: 'Click',
    CONNECT_TO_START: " para empezar o ",
    TIP: 'Tip',
    ACTION: "Acción",
    ACTIONS: "Acciones",
    ADVANCED_SEARCH_TIP: "utilice una nueva línea o comas para separar sus entradas de dominio.",
    ADVANCED_SEARCH: "Bsqueda avanzada.",
    ADVANCED_MODE: "Modo avanzado",
    REGISTER_DOMAINS_TO: "Registrar Dominios a",
    NO_DOMAINS_SELECTED: "No hay dominios seleccionados.",
    FIND_AND_REGISTER: "Buscar dominios por ejemplo dominio1, dominio2...",
    SELECTED_DOMAINS: "Dominios seleccionados",
    REGISTER: "Registrarse",
    BOOKMARKS: "Marcadores",
    SEARCH_RESULTS: "Resultados de búsqueda",
    PROCEED_TO_REGISTRATION: "Continuar con el registro",
    REGISTER_DOMAINS: "Registrar Dominios a",
    REGISTRANT_ADDRESS: "Registrar dirección",
    SET_RESOLVER: "Definir Resolver",
    TOTAL_COST: "Coste total",
    GAS_PRICE: "Precio gas",
    NO_ADDRESS_DETECTED: "Ninguna dirección detectada.",
    DURATION: "Duración",
    NOTICE_SELECT_AN_RPC: "Aviso: seleccione un RPC que se utilizará en la aplicación para reemplazar al proveedor RPC predeterminado.",
    ENABLE_LIGHT_MODE: "Activar estilo de diseño de luz.",
    CLICK_NEXT_TO_PROCEED: "Haga clic en <b>Next</b> para continuar."
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: "Registro cancelado",
    REGISTRATION_CANCELLED_DESCRIPTION: "Tu registro ha sido cancelado.",
    CANCEL_REGISTRATION_TITLE: "Cancelar Registro",
    CANCEL_REGISTRATION_DESCRIPTION: "¿Estás seguro que deseas eliminar este configuración? ¡Esta acción no se puede deshacer!",
    BEFORE_COMMIT: "Paso 1: solicitar registro.",
    COMMIT_SENT: "Procesando solicitud...",
    COMMIT_COMPLETE: "Paso 1: solicitar registro...",
    AWAIT: "Procesando solicitud...",
    BEFORE_REGISTRATION: "Finalización de registro",
    REGISTRATION_SENT: "Completando registro...",
    REGISTRATION_COMPLETE: "Fecha de registro!",
    REGISTRATION_COMPLETE_TITLE: "Registro completado",
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED: "Tus dominios han sido registrados.",
    BASKET_EMPTY: "Tu cesta está vacía",
    PLEASE_SELECT_DOMAINS_TO_REGISTER: "Por favor, seleccione nuevos dominios para registrarse."
  },
  PAYMENT: {
    PAYMENT_CANCELLED: "Transacción cancelada. Por favor, inténtelo de nuevo."
  },
  SPINNER: {
    SETUP_COMPLETE: "Configuración exitosa",
    LEDGER_NO_DEVICE_SELECTED: "Se produjo un error al crear el cupón. Por favor, inténtalo de nuevo.",
    NO_DATA_TO_DISPLAY: "No hay elementos para mostrar.",
    PERFORMING_SEARCH: "Realizando búsqueda...",
    LOADING_DATA: "Cargando datos...",
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET: "Siga las instrucciones de su cartera para continuar."
  },
  FORM_LABELS: {
    ENTER_DURATION: "Introducir duración",
    ENTER_QR_LINK: "Introduzca la URL personalizada del código QR",
    ENTER_PRICE: "Introducir precio",
    ENTER_CUSTOM_ADDRESS: "Introduzca dirección personalizada",
    ENTER_RECEIVER_ADDRESS: "Introduzca la dirección del receptor"
  },
  FORM_ERRORS: {
    INVALID_DURATION: "Duración no válida",
    INVALID_QR_LINK: "URL no válida, por favor inténtelo de nuevo.",
    INVALID_PRICE: "Precio no válido, por favor inténtalo de nuevo.",
    NO_ADDRESS_DETECTED: "No se ha detectado ninguna dirección, inténtelo de nuevo.",
    INVALID_ADDRESS: "Código no válido. Inténtelo de nuevo."
  },
  STEP: {
    STEP_1: "Paso 1",
    STEP_2: "Paso 2",
    STEP_3: "Paso 3",
    STEP_4: "Paso 4",
    STEP_5: "Paso 5"
  },
  RENEW: {
    RENEWAL_COST: "Coste de Renovación",
    ESTIMATED_RENEWAL_COST: "A continuación se muestra el costo estimado de renovación de esta transacción.",
    RENEWAL_COMPLETE: "Renovación Completa",
    DOMAINS_READY_FOR_RENEWAL: " Tus dominios están listos para la renovación. Para completar la prensa, procede."
  },
  TRANSFER: {
    TRANSFER_TO: "Transferir",
    TRANSFER_COMPLETE: "¡Transferencia completada!",
    SETUP_INSTRUCTION: "Para activar la administración de dominios ENS, su cuenta debe estar configurada para aprobar transferencias de dominios.",
    CONTRACT_APPROVAL_NOTE: "La aprobación del contrato permite que el contrato realice la transferencia de dominios en su nombre.",
    DOMAINS_READY_FOR_TRANSFER: "Tus dominios están listos para ser transferidos. Introduce la dirección del destinatario y pulsa continuar."
  }
};